<template>
    <div class="compare-widget-wrapper">
        <div class="skill-header">
            {{ title }}
        </div>
        <div class="skill-body">
            <div class="skill-filter-location-wrapper">
                <div class="skill-filter-left-location">
                    <div class="location">
                        {{ leftData.selectedDepartment ? leftData.selectedDepartment : "All" }}
                    </div>
                    <div class="department">
                        {{ leftData.selectedTeam ? leftData.selectedTeam : "All" }}
                    </div>
                </div>
                <div class="skill-filter-right-location">
                    <div class="location">
                        {{ rightData.selectedDepartment ? rightData.selectedDepartment : "All" }}
                    </div>
                    <div class="department">
                        {{ rightData.selectedTeam ? rightData.selectedTeam : "All" }}
                    </div>
                </div>
            </div>
            <div class="chart-progress-item" v-for="(item, index) in  skillData.skills" :key="index">
                <div class="chart-progress-wrapper chart-bar-left">
                    <div class="chart-progress-bar"
                        :style="{ width: `${calculateParcentage(skillData.left_count, item.leftSkillLevel)}%`, background: `${item.color}` }">
                    </div>
                </div>
                <div class="skill-name" :title="item.skillName">
                    {{ item.skillName }}
                </div>
                <div class="chart-progress-wrapper chart-bar-right">
                    <div class="chart-progress-bar"
                        :style="{ width: `${calculateParcentage(skillData.right_count, item.rightSkillLevel)}%`, background: `${item.color}` }">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { eventBus } from "@/main";

export default {
    components: {

    },
    props: {
        title: {
            type: String,
            default: "--"
        },
        skillData: {
            type: Object,
            default: () => {
                return {
                    skillSection: "Tools",
                    leftLocation: {
                        location: "Sweden, Stockholm",
                        department: "Department, Team"
                    },
                    rightLocation: {
                        location: "Sweden, Stockholm",
                        department: "Department, Team"
                    },
                    skills: [
                        {
                            skillName: "Java",
                            leftSkillLevel: 10,
                            rightSkillLevel: 30,
                            color: "#FFC236"
                        },
                        {
                            skillName: "JavaScript",
                            leftSkillLevel: 60,
                            rightSkillLevel: 20,
                            color: "#FE69C3"
                        },
                        {
                            skillName: "Python",
                            leftSkillLevel: 50,
                            rightSkillLevel: 90,
                            color: "#FF5D22"
                        },
                        {
                            skillName: "Photoshop",
                            leftSkillLevel: 10,
                            rightSkillLevel: 50,
                            color: "#1BA5A4"
                        },
                        {
                            skillName: "C#",
                            leftSkillLevel: 60,
                            rightSkillLevel: 90,
                            color: "#1890BD"
                        }
                    ]
                }
            }
        },
        leftData: {
            type: Object,
            default: () => null
        },
        rightData: {
            type: Object,
            default: () => null
        }
    },
    data: () => ({

    }),
    mounted() {
        let vm = this;

    },
    computed: {

    },
    watch: {

    },
    methods: {
        calculateParcentage(total, value) {
            return (value * 100) / total;
        }
    },

};
</script>
  
<style lang="scss" scoped>
.compare-widget-wrapper {
    background: #fff;
    border-radius: 5px;
    position: relative;

    &::after {
        position: absolute;
        content: "";
        height: 14px;
        background-color: #fff;
        left: 0px;
        right: 0px;
        bottom: 7px;
    }

    .skill-header {
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .skill-body {
        margin-bottom: 16px;
        height: 300px;
        overflow-y: auto;
        padding: 0px 10px;

        .skill-filter-location-wrapper {
            display: flex;
            justify-content: space-between;
            padding: 0px 10px;

            .skill-filter-left-location,
            .skill-filter-right-location {
                display: flex;
                flex-direction: column;
                padding: 10px 0px;


                .location {
                    font-family: 'Nunito';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 16px;
                    color: #000000;
                }

                .department {
                    font-family: 'Nunito';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 13px;
                    color: #656565;
                }
            }
        }

        .chart-progress-item {
            display: flex;
            align-items: center;
            height: 30px;


            .chart-progress-wrapper {
                width: calc(100% - 200px);
                height: 100%;
                display: flex;
                padding-bottom: 5px;


                &.chart-bar-left {
                    justify-content: flex-end;
                    border-right: 2px solid #000000;
                }

                &.chart-bar-right {
                    border-left: 2px solid #000000;
                }

                .chart-progress-bar {
                    height: 100%;
                }
            }

            .skill-name {
                width: 200px;
                font-family: "Nunito";
                height: 100%;
                text-decoration: none;
                text-overflow: ellipsis;
                white-space: nowrap;
                padding: 0px 8px;
                padding-top: 3px;
                display: inline-block;
                width: 180px;
                white-space: nowrap;
                overflow: hidden !important;
                text-overflow: ellipsis;
                cursor: pointer;
            }
        }
    }
}
</style>
  